import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';

interface Props {
  isTextVisible?: boolean;
}

const Main = styled.form``;

const Bottom = styled.div`
  padding: var(--space-16);
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
`;

const FormButton = styled.div`
  display: flex;
  gap: var(--space-12);
  align-items: flex-end;
  justify-content: flex-end;
`;
const Form = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
`;
const Field = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;

const Label = styled.label`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  span {
    ${Typography.body_md}
  }
`;

const Text = styled.div<Props>`
  ${Typography.body_lg}
  color: var(--text-secondary);
  margin: var(--space-0);
  ${(props: Props) =>
    props.isTextVisible &&
    css`
      display: none;
    `}
`;

export { Main, Bottom, FormButton, Form, Label, Field, Text };
